import xhr from 'Common/utils/xhr'
import { studentSignUp, studentCheckEmail } from 'Endpoints'
import memoizeOne from 'memoize-one'

const validateEmail = email =>
  xhr({
    url: studentCheckEmail,
    method: 'POST',
    data: { email },
  })

// since formik validates a lot of times the username and email fields, then we store the responses in memory
export const checkEmail = memoizeOne(validateEmail)

export const submitSignup = data => {
  return xhr({
    method: 'POST',
    url: studentSignUp,
    data,
  })
}

export async function signIn(data) {
  return xhr({
    url: '/students/sign_in',
    method: 'POST',
    data,
  })
}
